// Gerçek Kapsül "K" logosu (turkuaz + kırmızı kenar, şeffaf zemin).
// PNG varlığı public/logo192.png (website-ui ile aynı). Vektör yolu da
// (LOGO_PATH) illüstrasyon vb. için dışa aktarılır.
export const LOGO_PATH =
  'M22.9272 0H14.9434C14.9434 0 13.3222 0.139056 12.3115 1.64832C11.3008 3.15758 7.60396 8.72997 7.60396 8.72997L5.63683 5.72841H0.0474823C0.0474823 5.72841 1.15314 9.4422 1.2922 9.97468C1.43125 10.5106 1.70936 11.5043 1.76702 11.8299C1.79755 11.9791 2.15027 13.4952 2.18419 14.5025C2.18419 14.7602 2.27915 16.724 2.04852 18.0297C1.95356 18.5147 1.8959 19.539 1.08192 21.9063C0.484998 23.8599 0 25.3827 0 25.3827H4.08687C4.08687 25.3827 5.75554 25.2097 6.67127 23.8429C6.93921 23.4359 10.3037 18.5012 10.3037 18.5012L12.7829 22.2523H9.65248L7.51578 25.3963H18.5079L12.1894 15.7472L22.9272 0ZM4.3582 21.713C4.73467 20.665 5.0026 18.9794 5.06704 18.5113C5.78606 13.6953 4.2768 9.31672 4.2768 9.31672L7.55987 14.3125C7.55987 14.3125 14.6483 3.73076 14.8484 3.4289C15.0485 3.13044 15.2554 3.15758 15.2554 3.15758H17.0496C17.0496 3.15758 4.51421 21.5536 4.3582 21.713Z';

// Sadece "K" işareti (currentColor) — tek renk gereken yerler için.
export const LogoMark = ({ className = '' }: { className?: string }) => (
  <svg
    viewBox="0 0 23 26"
    fill="currentColor"
    className={className}
    role="img"
    aria-label="Kapsül"
  >
    <path d={LOGO_PATH} />
  </svg>
);

// Gerçek logo (şeffaf PNG) — navbar/footer marka kilidinde kullanılır.
const BrandLogo = ({
  size = 36,
  className = '',
}: {
  size?: number;
  className?: string;
}) => (
  <img
    src={`${process.env.PUBLIC_URL}/logo192.png`}
    alt="Kapsül"
    width={size}
    height={size}
    className={`shrink-0 object-contain ${className}`}
  />
);

export default BrandLogo;
